import React, { useContext, useEffect, useState } from "react";
import {
  Col,
  Row,
  Form,
  Input,
  message,
  Select,
  Button,
  DatePicker,
  Modal,
  Radio // Added Radio component
} from "antd";
// import { UploadOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import "dayjs/locale/en";
import { IoIosInformationCircle } from "react-icons/io";
import { UploadFile } from "antd/lib/upload";
import Upload, { RcFile, UploadChangeParam } from "antd/es/upload";
import { BiSolidInbox, BiUpload } from "react-icons/bi";
import { MdDeleteOutline } from "react-icons/md";
import { AuthContext } from "../../Auth/AuthContext";
import {
  UploadOutlined, ArrowLeftOutlined, FileOutlined,
  FileImageOutlined,
  FilePdfOutlined,
  FileWordOutlined,
  FileExcelOutlined,
  FilePptOutlined,
  EyeOutlined,
  DeleteOutlined,
  MailOutlined
} from "@ant-design/icons";
import { addDeveloper, fetchDesignations, getAllrole } from "../../utils/API";
const { Option } = Select;

interface developersFormModalProps {
  visible: boolean;
  onClose: () => void;
  onTaskCreated: () => void;
}
const AddDeveloperModal: React.FC<developersFormModalProps> = ({ visible, onClose, onTaskCreated }) => {
  const navigate = useNavigate();

  const { authData } = useContext(AuthContext);
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [profileFileList, setProfileFileList] = useState<UploadFile[]>([]); // Separate file list for profile photo
  const [documentFileList, setDocumentFileList] = useState<UploadFile[]>([]); // Separate file list for documents
  const [previewImage, setPreviewImage] = useState<string>("");
  const [apiImageUploaded, setApiImageUploaded] = useState(false);
  const [form] = Form.useForm(); // Use Form hook to get form instance
  const [isLoading, setIsLoading] = React.useState(false);
  const user_id = authData.user._id;
  const id = user_id.replace(/["']/g, "");
  const imageUrl = process.env.REACT_APP_Image_URL || "";
  const [country, setCountry] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [state, setState] = useState([]);
  const [showAdminContact, setShowAdminContact] = useState(false);
  const [designations, setDesignations] = useState<Designation[]>([]);
  const [roles, setRoles] = useState<any>([]);
  const [panAadharData, setPanAadharData] = useState({
    pan: null,
    aadhar: null,
  });
  const [documents, setDocuments] = useState<string[]>([]); // Define state for documents as an array of strings
  const roleId = authData.roleId;


  interface Designation {
    _id: string;
    name: string;
    // roleId: string; // Added roleId property
  }


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("/uploads/country.json");
        if (!response.ok) {
          throw new Error("Failed to fetch");
        }
        const data = await response.json();
        setCountry(data); // Ensure data is set correctly
      } catch (error) {
        // console.error("Error fetching country data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("/uploads/States.json");
        if (!response.ok) {
          throw new Error("Failed to fetch");
        }
        const data = await response.json();
        setState(data); // Ensure data is set correctly
      } catch (error) {
        // console.error("Error fetching country data:", error);
      }
    };

    fetchData();
  }, []);

  const getBase64 = (file: File | Blob) =>
    new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });


  const imageProps = {
    name: 'photo',
    multiple: false,
    beforeUpload(file: any) {
      const isImage = file.type.startsWith('image/');
      if (!isImage) {
        message.error('You can only upload image files!');
      }
      const isLt64M = file.size / 1024 / 1024 < 64;
      if (!isLt64M) {
        message.error('Image must be smaller than 64MB!');
      }
      return isImage && isLt64M;
    },
    onChange(info: any) {
      const newFileList = [...info.fileList];
      if (newFileList.length > 0) {
        const file = newFileList[0];
        if (!file.url && !file.preview) {
          getBase64(file.originFileObj).then(preview => {
            file.preview = preview;
            setPreviewImage(preview);
          });
        } else {
          setPreviewImage(file.url || file.preview || '');
        }
      } else {
        setPreviewImage('');
      }
      setProfileFileList(newFileList.slice(-1)); // Only keep the last uploaded profile photo
    },
    fileList: profileFileList,
  };

  const documentProps = {
    name: 'documents',
    multiple: true,
    beforeUpload(file: any) {
      const allowedTypes = [
        'image/jpeg', 'image/jpg', 'image/png', 'image/gif',
        'application/pdf',
        'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
      ];

      const isAllowedType = allowedTypes.includes(file.type);
      if (!isAllowedType) {
        message.error('You can only upload document files (images, PDF, Word, Excel, PowerPoint)!');
        return Upload.LIST_IGNORE;
      }

      const isLt64M = file.size / 1024 / 1024 < 64;
      if (!isLt64M) {
        message.error('Document must be smaller than 64MB!');
        return Upload.LIST_IGNORE;
      }

      return false; // Prevent auto upload
    },
    onChange(info: UploadChangeParam<UploadFile>) {
      setDocumentFileList(info.fileList);
    },
    fileList: documentFileList,
  };



const handleSubmit = async (values: any) => {
  try {
    setIsLoading(true);

    const formData = new FormData();

    // Append regular form fields
    formData.append("roleId", values.roleId);
    formData.append("designation", values.designation);
    formData.append("email", values.email);
    formData.append("pemail", values.pemail || "");
    formData.append("username", values.username);
    formData.append("mobileNo", values.mobileNo);
    formData.append("password", values.password);
    formData.append("dob", values.dob ? dayjs(values.dob).format('YYYY-MM-DD') : '');
    
    // IMPORTANT: Ensure employmentType is sent correctly
    const employmentTypeValue = values.employmentType !== undefined && values.employmentType !== null 
      ? values.employmentType 
      : 1; // Default to 1 (Employee)
    
    console.log("Sending employmentType:", employmentTypeValue); // Debug log
    formData.append("employmentType", String(employmentTypeValue));
    
    formData.append("joining_date", values.joining_date ? dayjs(values.joining_date).format('YYYY-MM-DD') : '');
    formData.append("exit_date", values.exit_date ? dayjs(values.exit_date).format('YYYY-MM-DD') : '');
    formData.append("country", values.country);
    formData.append("city", values.city);
    formData.append("state", values.state);
    formData.append("address", values.address);
    formData.append("pincode", values.pincode);

    // Append the profile photo if it was uploaded
    if (profileFileList.length > 0 && profileFileList[0].originFileObj) {
      formData.append("photo", profileFileList[0].originFileObj);
    }

    // Append the documents
    documentFileList.forEach((file) => {
      if (file.originFileObj) {
        formData.append("document", file.originFileObj);
      }
    });

    // Debug logging - manually log the important fields
    console.log("Form Data Debug:");
    console.log("roleId:", values.roleId);
    console.log("designation:", values.designation);
    console.log("username:", values.username);
    console.log("email:", values.email);
    console.log("mobileNo:", values.mobileNo);
    console.log("employmentType:", employmentTypeValue);
    console.log("dob:", values.dob);
    console.log("joining_date:", values.joining_date);
    console.log("country:", values.country);
    console.log("city:", values.city);
    console.log("state:", values.state);
    console.log("address:", values.address);
    console.log("pincode:", values.pincode);
    console.log("Profile photo:", profileFileList.length > 0 ? "Yes" : "No");
    console.log("Documents count:", documentFileList.length);

    const response = await addDeveloper(formData);

    if (response && response.data) {
      message.success("Developer added successfully!");
      form.resetFields();
      setProfileFileList([]);
      setDocumentFileList([]);
      setPreviewImage("");
      onClose();
      onTaskCreated();
      navigate("/developers");
    } else {
      message.error("Failed to add developer. Please try again.");
    }
  } catch (error) {
    console.error("Error adding developer:", error);
    message.error("An error occurred while adding the developer.");
  } finally {
    setIsLoading(false);
  }
};

  // In the useEffect for fetching designations:
  // Update the useEffect for fetching designations in AddDeveloper component
  useEffect(() => {
    const getDesignations = async () => {
      try {
        setIsLoading(true);
        const response: any = await fetchDesignations("", 1); // Pass empty search text and page 1

        // Check if response has data property (assuming API returns {data: [...]})
        if (response?.data) {
          setDesignations(response.data);
        } else if (Array.isArray(response)) {
          // If API directly returns array
          setDesignations(response);
        } else {
          message.error("Failed to load designations");
          setDesignations([]);
        }
      } catch (error) {
        console.error("Error fetching designations:", error);
        message.error("Error loading designations");
      } finally {
        setIsLoading(false);
      }
    };

    getDesignations();
  }, []); // fetchDesignations
  useEffect(() => {
    const getRoles = async () => {
      try {
        const response: any = await getAllrole(); // Call API function
        // console.log("roles", response);

        if (Array.isArray(response)) {
          setRoles(response); // Directly set response since it's an array
        }
      } catch (error) {
        // console.error("Error fetching roles:", error);
      }
    };

    getRoles();
  }, []);
  const handleCancel = () => {
    setIsModalOpen(false); // This now works
  };


  return (
    <Modal
      visible={visible}
      onCancel={onClose}
      footer={null}
      width={700}
      centered={false} // Disable centered to use top positioning
      destroyOnClose
      className="custom-modal"
      bodyStyle={{
        overflowY: "auto",
        fontFamily: "inter, sans-serif",
      }}
      style={{
        bottom: 20,
        top: 20,
        // maxHeight: 'calc(100vh - 30px)',
        margin: '0 auto',
        position: 'relative',
      }}
      styles={{
        header: {
          padding: "12px",
          position: "relative",
          top: 0,
          backgroundColor: "#f1f5ffff",
          maxHeight: 'calc(100vh - 30px)',
        },
        content: {
          padding: 0,
          overflow: "hidden",
        },
      }}
      title={
        <div
          style={{
            color: "#4b5563",
            fontFamily: "inter, sans-serif",
            fontSize: "20px",
            fontWeight: 500,
          }}
        >
          Create New Developer
        </div>
      }
    >
      <Form
  onFinish={handleSubmit}
  form={form}
  layout="horizontal"
  labelCol={{ span: 5 }}
  wrapperCol={{ span: 19 }}
  colon={false}
  initialValues={{
    country: "India",
    state: "Gujarat",
    employmentType: 1 // Set default to Employee (1)
  }}
>

        <div className="elements">

          {/* Profile image */}
          <Form.Item
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            className="w-full"
          >
            <div className="flex justify-center ">
              <div className="relative w-20 h-20">
                <Upload.Dragger
                  {...imageProps}
                  className="w-full h-full rounded-full border-2 border-dashed border-gray-300 flex items-center justify-center hover:border-blue-500 transition-colors bg-gray-50 overflow-hidden"
                  showUploadList={false}
                >
                  {!previewImage ? (
                    <div className="flex flex-col items-center p-1">
                      <div className="w-6 h-6 rounded-full bg-gray-200 flex items-center justify-center">
                        <UploadOutlined className="text-gray-400 text-base" />
                      </div>
                      <span className="text-xs text-gray-400 mt-1">Profile</span>
                    </div>

                  ) : (
                    <img
                      src={previewImage}
                      alt="Uploaded"
                      className="w-full h-full object-cover"
                    />
                  )}
                </Upload.Dragger>

                {previewImage && (
                  <Button
                    type="text"
                    shape="circle"
                    size="small"
                    icon={<MdDeleteOutline size={16} />}
                    className="absolute top-0 right-0 bg-red-500 text-white hover:bg-red-600 shadow-sm"
                    onClick={(e) => {
                      e.stopPropagation();
                      setPreviewImage("");
                      setFileList([]);
                    }}
                  />
                )}
              </div>
            </div>
          </Form.Item>

          {/* {role } */}
          <Col xs={24} sm={24} md={24} xl={24} xxl={24}>
            <div className="bg-white">
              <Form.Item
                label={<span style={{
                  color: '#4b5563',
                  fontFamily: 'inter, sans-serif',
                  fontSize: '14px',
                  paddingLeft: "15px",
                  fontWeight: 500,
                }}>Role<span className="text-red-500">*</span></span>}
                name="roleId"
                rules={[{ required: true, message: "Please select Role" }]}
                required={false}
              >
                <Select
                  allowClear
                  size="large"
                  className="CustomSelect"
                  placeholder="Select Role"
                >
                  {roles
                    .filter((item: any) => item.isActive === true)
                    .map((item: any) => (
                      <Option key={item._id} value={item._id}>
                        {item.name}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </div>
          </Col>


          {/* {Designation} */}
          <Col xs={24} sm={24} md={24} xl={24} xxl={24} className="bg-white">


            <Form.Item
              label={<span style={{
                color: '#4b5563',
                fontFamily: 'inter, sans-serif',
                fontSize: '14px',
                paddingLeft: "15px",
                fontWeight: 500,
              }}>Designation<span className="text-red-500">*</span></span>}
              required={false}
              name="designation"
              rules={[{ required: true, message: "Please select Designation" }]}
            >
              <Select
                size="large"
                loading={isLoading}
                disabled={roleId === 2}
                className="CustomSelect"
                placeholder={isLoading ? "Loading..." : "Select Designation"}
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (String(option?.children) ?? '').toLowerCase().includes(input.toLowerCase())
                }
              >
                {designations.map((item) => (
                  <Option key={item._id} value={item._id}>
                    {item.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          {/* Username */}
          <Col xs={24} sm={24} md={24} xl={24} xxl={24} className="bg-white">
            {/* Label placed above the input */}


            {/* Input field */}
            <Form.Item
              label={<span style={{
                color: '#4b5563',
                fontFamily: 'inter, sans-serif',
                fontSize: '14px',
                paddingLeft: "15px",
                fontWeight: 500,
              }}>Username<span className="text-red-500">*</span></span>}
              required={false}
              name="username"
              rules={[
                {
                  required: true,
                  message: "Please Enter Username",
                },
              ]}

            >
              <Input
                size="large"
                disabled={roleId == 2}
                className="Allinput"
                placeholder="Username"
              />
            </Form.Item>
          </Col>
          {/* Email */}
          <Col xs={24} sm={24} md={24} xl={24} xxl={24} className="bg-white mb-4">

            {/* Input Field */}
            <Form.Item
              label={<span style={{
                color: '#4b5563',
                fontFamily: 'inter, sans-serif',
                fontSize: '14px',
                paddingLeft: "15px",
                fontWeight: 500,
              }}>Email<span className="text-red-500">*</span></span>}
              required={false}

              name="email"

              rules={[
                {
                  required: true,
                  message: "Please Enter Email",
                },
                {
                  type: 'email',
                  message: 'Please enter a valid email address',
                }
              ]}
            >
              <Input
                size="large"
                disabled={roleId == 2}
                className="Allinput"
                placeholder="Enter email address"
              />
            </Form.Item>
          </Col>
          {/* email prosonal */}
          <Col xs={24} sm={24} md={24} xl={24} xxl={24} className="bg-white mb-4">


            {/* Input Field */}
            <Form.Item
              label={<span style={{
                color: '#4b5563',
                fontFamily: 'inter, sans-serif',
                fontSize: '14px',
                paddingLeft: "15px",
                fontWeight: 500,
              }}>Personal Email<span className="text-red-500">*</span></span>}
              required={false}

              name="pemail"
              rules={[
                {
                  type: 'email',
                  message: 'Please enter a valid email address',
                }
              ]}
            >
              <Input
                size="large"
                disabled={roleId == 2}
                className="Allinput"
                placeholder="Enter personal email address"
              // prefix={<MailOutlined className="text-gray-400" />}  
              />
            </Form.Item>
          </Col>
          {/* password */}
          <Col xs={24} sm={24} md={24} xl={24} xxl={24}>
            <Row className="bg-white">

              <Col span={24}>
                <Form.Item
                  label={<span style={{
                    color: '#4b5563',
                    fontFamily: 'inter, sans-serif',
                    fontSize: '14px',
                    paddingLeft: "15px",
                    fontWeight: 500,
                  }}>Password<span className="text-red-500">*</span></span>}
                  required={false}

                  name="password"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Password",
                    },
                  ]}
                >
                  <Input
                    size="large"
                    type="password"
                    disabled={roleId === 2}
                    className="Allinput"
                    placeholder="Please Enter Password"
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>

          {/* Date of Birth */}
          <Col xs={24} sm={24} md={24} xl={24} xxl={24}>
            <Row className="bg-white">

              <Col span={24}>
                <Form.Item
                  label={<span style={{
                    color: '#4b5563',
                    fontFamily: 'inter, sans-serif',
                    fontSize: '14px',
                    paddingLeft: "15px",
                    fontWeight: 500,
                  }}>Dob<span className="text-red-500">*</span></span>}
                  name="dob"
                  required={false}

                  rules={[
                    {
                      required: true,
                      message: "Please Enter DOB",
                    },
                  ]}
                >
                  <DatePicker
                    format="DD-MM-YYYY"
                    disabled={roleId == 2}
                    className="Allinput"
                    placeholder="Select DOB"
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>

           
{/* Employment Type Radio Button */}
<Col xs={24} sm={24} md={24} xl={24} xxl={24}>
  <Row className="bg-white">
    <Col span={24}>
      <Form.Item
        label={<span style={{
          color: '#4b5563',
          fontFamily: 'inter, sans-serif',
          fontSize: '14px',
          paddingLeft: "2px",
          fontWeight: 500,
        }}>Employment Type<span className="text-red-500">*</span></span>}
        name="employmentType"
        required={false}
        rules={[
          {
            required: true,
            message: "Please select employment type",
          },
          {
            validator: (_, value) => {
              if (value === undefined || value === null) {
                return Promise.reject("Please select employment type");
              }
              return Promise.resolve();
            }
          }
        ]}
      >
        <Radio.Group>
          <Radio value={1}>Full Time</Radio>
          <Radio value={0}>Trainee</Radio>
        </Radio.Group>
      </Form.Item>
    </Col>
  </Row>
</Col>

          {/* Joining Date */}
          <Col xs={24} sm={24} md={24} xl={24} xxl={24}>
            <Row className="bg-white">

              <Col span={24}>
                <Form.Item
                  label={<span style={{
                    color: '#4b5563',
                    fontFamily: 'inter, sans-serif',
                    fontSize: '14px',
                    paddingLeft: "15px",
                    fontWeight: 500,
                  }}>Joining Date<span className="text-red-500">*</span></span>}
                  name="joining_date"
                  required={false}

                  rules={[
                    {
                      required: true,
                      message: "Please Enter Joining Date",
                    },
                  ]}
                >
                  <DatePicker
                    format="DD-MM-YYYY"
                    disabled={roleId == 2}
                    className="Allinput"
                    placeholder="Select Joining Date"
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>

          {/* Exit Date */}
          <Col xs={24} sm={24} md={24} xl={24} xxl={24}>
            <Row className="bg-white">

              <Col span={24}>
                <Form.Item
                  label={<span style={{
                    color: '#4b5563',
                    fontFamily: 'inter, sans-serif',
                    fontSize: '14px',
                    paddingLeft: "15px",
                    fontWeight: 500,
                  }}>Exit Date</span>}
                  name="exit_date"
                  required={false}
                >
                  <DatePicker
                    format="DD-MM-YYYY"
                    disabled={roleId == 2}
                    className="Allinput"
                    placeholder="Select Exit Date"
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>

          {/* Contact */}
          <Col xs={24} sm={24} md={24} xl={24} xxl={24}>
            <Row className="bg-white">

              <Col span={24}>
                <Form.Item
                  label={<span style={{
                    color: '#4b5563',
                    fontFamily: 'inter, sans-serif',
                    fontSize: '14px',
                    paddingLeft: "15px",
                    fontWeight: 500,
                  }}>Contact<span className="text-red-500">*</span></span>}
                  name="mobileNo"
                  rules={[
                    { required: true, message: "Please enter mobile number" },
                    { pattern: /^[0-9]{10}$/, message: "Enter a valid 10-digit mobile number" },
                  ]}
                  required={false}
                >
                  <Input
                    size="large"
                    type="number"
                    disabled={roleId == 2}
                    className="Allinput"
                    placeholder="Contact"
                  />
                </Form.Item>
                {showAdminContact && (
                  <div style={{ color: 'gray', fontSize: '12px' }}>
                    Please contact administrator
                  </div>
                )}
              </Col>
            </Row>
          </Col>

          {/* Address */}
          <Col xs={24} sm={24} md={24} xl={24} xxl={24}>
            <Row className="bg-white">

              <Col span={24}>
                <Form.Item
                  label={<span style={{
                    color: '#4b5563',
                    fontFamily: 'inter, sans-serif',
                    fontSize: '14px',
                    paddingLeft: "15px",
                    fontWeight: 500,
                  }}>Address<span className="text-red-500">*</span></span>}
                  name="address"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Address",
                    },
                  ]}
                  required={false}
                >
                  <Input.TextArea
                    rows={4}
                    cols={30}
                    size="large"
                    className="Allinputtextarea"
                    placeholder="Address"
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>

          {/* Country */}
          <Col xs={24} sm={24} md={24} xl={24} xxl={24}>
            <Row className="bg-white">

              <Col span={24}>
                <Form.Item
                  label={<span style={{
                    color: '#4b5563',
                    fontFamily: 'inter, sans-serif',
                    fontSize: '14px',
                    paddingLeft: "15px",
                    fontWeight: 500,
                  }}>Country<span className="text-red-500">*</span></span>}
                  name="country"
                  rules={[
                    {
                      required: true,
                      message: "Please Select country",
                    },
                  ]}
                  required={false}
                >
                  <Select
                    size="large"
                    className="CustomSelect"
                    placeholder="Select country"
                    allowClear
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input: any, option: any) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    {country.map((c: any) => (
                      <Option key={c.code} value={c.name} label={c.name}>
                        {c.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </Col>

          {/* States */}
          <Col xs={24} sm={24} md={24} xl={24} xxl={24}>
            <Row className="bg-white">

              <Col span={24}>
                <Form.Item
                  label={<span style={{
                    color: '#4b5563',
                    fontFamily: 'inter, sans-serif',
                    fontSize: '14px',
                    paddingLeft: "15px",
                    fontWeight: 500,
                  }}>State<span className="text-red-500">*</span></span>}
                  name="state"
                  rules={[
                    {
                      required: true,
                      message: "Please Select States",
                    },
                  ]}
                  required={false}
                >
                  <Select
                    size="large"
                    className="CustomSelect"
                    placeholder="Select States"
                    allowClear
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input: any, option: any) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    {state.map((c: any) => (
                      <Option key={c.code} value={c.name} label={c.name}>
                        {c.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </Col>


          {/* City */}
          <Col xs={24} sm={24} md={24} xl={24} xxl={24}>
            <Row className="bg-white">

              <Col span={24}>
                <Form.Item
                  label={<span style={{
                    color: '#4b5563',
                    fontFamily: 'inter, sans-serif',
                    fontSize: '14px',
                    paddingLeft: "15px",
                    fontWeight: 500,
                  }}>City<span className="text-red-500">*</span></span>}
                  name="city"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter city",
                    },
                  ]}
                  required={false}
                >
                  <Input
                    size="large"
                    className="Allinput"
                    placeholder="City"
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>

          {/* Pin Code */}
          <Col xs={24} sm={24} md={24} xl={24} xxl={24}>
            <Row className="bg-white">

              <Col span={24}>
                <Form.Item
                  label={<span style={{
                    color: '#4b5563',
                    fontFamily: 'inter, sans-serif',
                    fontSize: '14px',
                    paddingLeft: "15px",
                    fontWeight: 500,
                  }}>Pin Code<span className="text-red-500">*</span></span>}
                  name="pincode"
                  rules={[
                    { required: true, message: "Please enter a pincode" },
                    { pattern: /^[0-9]{6}$/, message: "Please enter a valid 6-digit pincode" },
                  ]}
                  required={false}
                >
                  <Input
                    size="large"
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    className="Allinput"
                    placeholder="Pin Code"
                    maxLength={6}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>
          {/* document */}
          <Col xs={24} sm={24} md={24} xl={24} xxl={24}>
            <Row className="bg-white">
              {/* Upload component and document displays */}
              <Col span={24}>
                <Form.Item
                  label={<span style={{
                    color: '#4b5563',
                    fontFamily: 'inter, sans-serif',
                    fontSize: '14px',
                    paddingLeft: "15px",
                    fontWeight: 500,
                  }}>Documents<span className="text-red-500">*</span></span>}
                  name="document"
                  // rules={[{ required: true, message: "Please upload at least one document" }]}
                  required={false}
                >
                  <Upload
                    {...documentProps}
                    listType="picture-card"
                    multiple
                    maxCount={10}
                    beforeUpload={() => false} // Prevent automatic upload
                    onRemove={(file) => {
                      const newFileList = documentFileList.filter(f => f.uid !== file.uid);
                      setDocumentFileList(newFileList);
                      return true;
                    }}
                    iconRender={(file) => {
                      const fileName = file.name || '';
                      const extension = fileName.split('.').pop()?.toLowerCase();
                      if (['jpg', 'jpeg', 'png', 'gif'].includes(extension || '')) {
                        return <FileImageOutlined />;
                      } else if (extension === 'pdf') {
                        return <FilePdfOutlined />;
                      } else if (['doc', 'docx'].includes(extension || '')) {
                        return <FileWordOutlined />;
                      } else if (['xls', 'xlsx'].includes(extension || '')) {
                        return <FileExcelOutlined />;
                      } else if (['ppt', 'pptx'].includes(extension || '')) {
                        return <FilePptOutlined />;
                      }
                      return <FileOutlined />;
                    }}
                    itemRender={(originNode, file) => {
                      const fileName = file.name || '';
                      const extension = fileName.split('.').pop()?.toLowerCase();
                      let icon = <FileOutlined />;

                      if (['jpg', 'jpeg', 'png', 'gif'].includes(extension || '')) {
                        icon = <FileImageOutlined />;
                      } else if (extension === 'pdf') {
                        icon = <FilePdfOutlined />;
                      } else if (['doc', 'docx'].includes(extension || '')) {
                        icon = <FileWordOutlined />;
                      } else if (['xls', 'xlsx'].includes(extension || '')) {
                        icon = <FileExcelOutlined />;
                      } else if (['ppt', 'pptx'].includes(extension || '')) {
                        icon = <FilePptOutlined />;
                      }

                      return (
                        <div className="ant-upload-list-item ant-upload-list-item-done">
                          <div className="ant-upload-list-item-info">
                            <span className="ant-upload-list-item-name">
                              {icon} {fileName}
                            </span>
                          </div>
                          <span className="ant-upload-list-item-actions">
                            <a
                              href={file.originFileObj ? URL.createObjectURL(file.originFileObj) : file.url || '#'}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <EyeOutlined />
                            </a>
                            <a onClick={() => {
                              const newFileList = documentFileList.filter(f => f.uid !== file.uid);
                              setDocumentFileList(newFileList);
                            }}>
                              <DeleteOutlined />
                            </a>
                          </span>
                        </div>
                      );
                    }}
                  >
                    {documentFileList.length >= 10 ? null : (
                      <Button icon={<UploadOutlined />}>Upload</Button>
                    )}
                  </Upload>

                  {/* Display newly uploaded documents */}
                  <div className="flex flex-wrap mt-2">
                    {documentFileList.map((file, index) => {
                      const fileName = file.name || '';
                      const extension = fileName.split('.').pop()?.toLowerCase();
                      let icon = <FileOutlined className="text-2xl" />;

                      if (['jpg', 'jpeg', 'png', 'gif'].includes(extension || '')) {
                        icon = <FileImageOutlined className="text-2xl" />;
                      } else if (extension === 'pdf') {
                        icon = <FilePdfOutlined className="text-2xl" />;
                      } else if (['doc', 'docx'].includes(extension || '')) {
                        icon = <FileWordOutlined className="text-2xl" />;
                      } else if (['xls', 'xlsx'].includes(extension || '')) {
                        icon = <FileExcelOutlined className="text-2xl" />;
                      } else if (['ppt', 'pptx'].includes(extension || '')) {
                        icon = <FilePptOutlined className="text-2xl" />;
                      }

                      return (
                        <div key={file.uid} className="relative mr-2 mb-2 p-2 border rounded-lg flex items-center">
                          <div className="mr-2">{icon}</div>
                          <div className="flex flex-col">
                            <span className="text-sm">{fileName}</span>
                            <div className="flex mt-1">
                              <a
                                href={file.originFileObj ? URL.createObjectURL(file.originFileObj) : file.url || '#'}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-500 mr-2"
                              >
                                <EyeOutlined />
                              </a>
                              <a
                                onClick={() => {
                                  const newFileList = documentFileList.filter((_, i) => i !== index);
                                  setDocumentFileList(newFileList);
                                }}
                                className="text-red-500 cursor-pointer"
                              >
                                <DeleteOutlined />
                              </a>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </Form.Item>
              </Col>
            </Row>
          </Col>

        </div>
        <Row justify="end">
          <Col
            xs={24}
            sm={24}
            md={24}
            xl={24}
            xxl={20}
            className="d-flex justify-content-end me-4"
          >
            <div className="button-wrapper">
              <button
                className="allcanclebutton"
                onClick={onClose}
                disabled={isLoading}
              >
                Cancel
              </button>

              <button className="allsubmitebutton" disabled={isLoading}>
                {isLoading ? "Adding..." : "Add"}
              </button>
            </div>
          </Col>
        </Row>



      </Form>

    </Modal>
  );
};

export default AddDeveloperModal;